export const eventSelectionStatuses = ['queued', 'selected'] as const

type EventSelectionStatus = typeof eventSelectionStatuses[number]
export default EventSelectionStatus
